module.exports = "//static.hsappstatic.net/salesImages/static-1.403/email-images/deals@3x.png"